import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/operator/map'
import 'rxjs/add/observable/of'
import { Router } from '@angular/router'

import { environment } from '../../../../environments/environment'
import { DeviceModel } from '../models/device.model'

@Injectable()
export class DeviceService {
  private readonly deviceUrl = environment.base_url + '/v1/device'
  private readonly activateDeviceUrl = environment.base_url + '/v1/device/activate/send'
  private readonly validateDeviceUrl = environment.base_url + '/v1/device/activate/validate'

  constructor(private router: Router, protected httpClient: HttpClient) {}

  /**
   *
   * @param info
   * @returns {any}
   */
  public getDevice(deviceInfo: any) {
    // return this.httpClient.post<DeviceModel>(this.deviceUrl, device);
    const device = JSON.parse(localStorage.getItem('device'))
    if (device === null) {
      //we should register a new device.
      const device = new DeviceModel()
      device.type = 3
      device.device_id = this.generateUUID()
      device.model = deviceInfo.browser_version
      device.make = deviceInfo.browser
      device.os_version = deviceInfo.os_version
      localStorage.setItem('device', JSON.stringify(device))
      return device
    } else {
      return device
    }
  }

  /**
   *
   * @param {DeviceModel} device
   * @returns {Observable<DeviceModel>}
   */
  public registerDevice(device: DeviceModel): Observable<DeviceModel> {
    return this.httpClient.post<DeviceModel>(this.deviceUrl, device)
  }

  /**
   *
   * @param {string} device_id
   * @returns {Observable<DeviceModel>}
   */
  public activateDevice(device_id: string): Observable<DeviceModel> {
    return this.httpClient.post<DeviceModel>(this.activateDeviceUrl, { device_id: device_id })
  }

  /**
   *
   * @param {number} code
   * @param {string} device_id
   * @returns {Observable<DeviceModel>}
   */
  public validateDevice(code: number, device_id: string): Observable<DeviceModel> {
    return this.httpClient.post<DeviceModel>(this.validateDeviceUrl, { activation_code: code, device_id: device_id })
  }

  /**
   * Generate a UUID
   * @returns {string}
   */
  generateUUID() {
    let d = new Date().getTime()
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = (d + Math.random() * 16) % 16 | 0
      d = Math.floor(d / 16)
      return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16)
    })
    return uuid
  }
}



// WEBPACK FOOTER //
// ./src/app/main/authentication/service/device.service.ts